<app-switcher-bar *ngIf="showSwitcher"></app-switcher-bar>
<app-nav></app-nav>
<router-outlet></router-outlet>
